module.exports = __webpack_public_path__ + "img/1485640.jpg";